// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
@keyframes dance {
    0% {
        transform: rotate(0deg) translate(0px, 0px);
    }
    25% {
        transform: rotate(15deg) translate(10px, 10px);
    }
    50% {
        transform: rotate(-15deg) translate(-10px, -10px);
    }
    75% {
        transform: rotate(10deg) translate(8px, 8px);
    }
    100% {
        transform: rotate(0deg) translate(0px, 0px);
    }
}

@keyframes bounce {
    0% {
        transform: translateY(0);
    }
    50% {
        transform: translateY(-20px);
    }
    100% {
        transform: translateY(0);
    }
}



@keyframes flash {
    0% {
        opacity: 0;
        transform: translateY(0); /* Start at the initial position */
    }
    50% {
        opacity: 1;
        transform: translateY(-20px); /* Move up and fade in */
    }
    100% {
        opacity: 0;
        transform: translateY(-40px); /* Move up and fade out */
    }
}`, "",{"version":3,"sources":["webpack://./src/styles.css"],"names":[],"mappings":";AACA;IACI;QACI,2CAA2C;IAC/C;IACA;QACI,8CAA8C;IAClD;IACA;QACI,iDAAiD;IACrD;IACA;QACI,4CAA4C;IAChD;IACA;QACI,2CAA2C;IAC/C;AACJ;;AAEA;IACI;QACI,wBAAwB;IAC5B;IACA;QACI,4BAA4B;IAChC;IACA;QACI,wBAAwB;IAC5B;AACJ;;;;AAIA;IACI;QACI,UAAU;QACV,wBAAwB,EAAE,kCAAkC;IAChE;IACA;QACI,UAAU;QACV,4BAA4B,EAAE,wBAAwB;IAC1D;IACA;QACI,UAAU;QACV,4BAA4B,EAAE,yBAAyB;IAC3D;AACJ","sourcesContent":["\n@keyframes dance {\n    0% {\n        transform: rotate(0deg) translate(0px, 0px);\n    }\n    25% {\n        transform: rotate(15deg) translate(10px, 10px);\n    }\n    50% {\n        transform: rotate(-15deg) translate(-10px, -10px);\n    }\n    75% {\n        transform: rotate(10deg) translate(8px, 8px);\n    }\n    100% {\n        transform: rotate(0deg) translate(0px, 0px);\n    }\n}\n\n@keyframes bounce {\n    0% {\n        transform: translateY(0);\n    }\n    50% {\n        transform: translateY(-20px);\n    }\n    100% {\n        transform: translateY(0);\n    }\n}\n\n\n\n@keyframes flash {\n    0% {\n        opacity: 0;\n        transform: translateY(0); /* Start at the initial position */\n    }\n    50% {\n        opacity: 1;\n        transform: translateY(-20px); /* Move up and fade in */\n    }\n    100% {\n        opacity: 0;\n        transform: translateY(-40px); /* Move up and fade out */\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
